type Listener = (message: string) => void

const listeners = new Set<Listener>()

/** Fire-and-forget notice. The Toaster subscribes; nothing else needs to. */
export const toast = (message: string): void => {
  for (const listener of listeners) listener(message)
}

export const subscribeToToasts = (listener: Listener): (() => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
